/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileUnchecked = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V16h-2V9h-5V4H6v16h8v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M22 20h-6v-2h6zm-8-3H8v-2h6zm2-4H8v-2h8zm-5-4H8V7h3z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileUnchecked as FileUnchecked };
